// extracted by mini-css-extract-plugin
module.exports = {"root":"Athletes_root__rMZua"};